export default __webpack_public_path__ + "static/MullerBlack-81476e27ac38bc8d8915295b0ed2062d.woff2";